// api/getRollString.js

import {ENDPOINT_URL} from '../constants/index';

import getFetchOptions from '../utils/getFetchOptions';

export default function getRollString(adminInfo) {
	return fetch(
		`${ENDPOINT_URL}/rollstring`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify(adminInfo),
		})
	).then((response) => {
		if (response.ok) {
			return response;
		}

		return Promise.reject(response);
	});
}
